import { authBetProcessor } from '@/lib/api';

function GetMaxBet(opts) {
  const url = `/placebet/maxbet?${opts}`;
  return authBetProcessor.get(url);
}

function getPresetSum(opts) {
  const url = `/placebet/maxbet/preset?outcomeId=${opts.outcomeId}&currency=${opts.currency}&betBuilder=${opts.isBetBuilder}`;
  return authBetProcessor.get(url);
}

function getShareBetCode(data) {
  const url = '/ticket-share';
  return authBetProcessor.post(url, data);
}

function getShareBetData(code) {
  const url = `/ticket-share?code=${code}`;
  return authBetProcessor.get(url);
}

function getHistory(opts) {
  const url = `/history/tickets?status=${opts.status}&page=${opts.page}&locale=${opts.language}`;
  return authBetProcessor.get(url);
}

export { GetMaxBet, getPresetSum, getShareBetCode, getShareBetData, getHistory };
